import React, { Fragment } from 'react'
import { graphql } from 'gatsby'
import styled, { css } from 'styled-components'
import Img from 'gatsby-image'
import {
  Row,
  Col,
  Gap,
  Text,
  TextNice,
  TitleNice,
  Section,
  Title,
  Button,
  VH,
  HpTop3,
  Video,
  Earth,
  Link,
  Fill,
  ImageOverlay,
  SEO,
  HpTopCarousel,
  HpShowReel,
} from '../components'
import { up } from '../lib/styles'
import { extractNodesFromData } from '../lib/helpers'

import planeVerticalSrc from '../data/images/hp/hybrid-vtol-propulsion-thrust-lift-distribution-technical.webp'
import planeHorizontalSrc from '../data/images/hp/zuri-hybrid-vtol-forward-flight-propulsion-cruise-mode-diagram.webp'
import plusIconSrc from '../data/images/hp/plus-icon.png'

import jobsVideo from '../data/videos/zuri-vtol-11m-test-behind-scenes-subscale-flight.mp4'

const PlaneImageWrapper = styled.div`
  height: 125px;
  width: 100%;
  position: relative;
  z-index: -1;
  ${up('mobile')} {
    height: 200px;
  }
`

const PlaneVertical = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%) scale(0.35);
  ${up('mobile')} {
    transform: none;

    /* top: -100px; */
    top: -120px;
    left: 50px;
    max-width: 340px;
  }
`

const PlaneVerticalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%) scale(0.35);
  ${up('mobile')} {
    transform: none;

    /* top: -100px; */
    top: -120px;
    left: 50px;
    max-width: 340px;
  }
`


const PlaneHorizontal = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  /* transform: translate(-46%, -48%) scale(0.25); */
  transform: translate(-43%, -47%) scale(0.45);

  ${up('mobile')} {
    transform: none;

    top: -140px;
    left: 80px;
    max-width: 700px;
  }
  ${up('tablet')} {
    transform: none;

    top: -170px;
    left: 118px;
    max-width: 700px;
  }
`
const EditorContent = styled.div`
  ${({ theme: { colors } }) => css`
    p {
      font-size: 24px;
      line-height: 33px;
      font-weight: 700;
      color: ${colors.textGray};
    }
    strong {
      color: ${colors.textBlack};
    }
    a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  `}
`

const InlineHeader = (props) => (
  <Text
    as="h2"
    black
    style={{ display: 'inline', textTransform: 'uppercase' }}
    {...props}
  />
)

const MainText = props => <Text fontWeight="400" {...props} />;

const Subtitle = (props) => <Title.Small innerAs="h3" mobileFontSize="20px" black {...props} />;

class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCareerVisible: false,
    }
  }

  careerOnMouseOver = () => {
    this.setState({ isCareerVisible: true })
  }

  careerOnMouseLeave = () => {
    this.setState({ isCareerVisible: false })
  }

  render() {
    const {
      location: { pathname },
      data: {
        topImage,
        earthImage,
        jobsBgImage,
        topImage1,
        topImage2,
        topImage3,
        ...restData
      } = {},
    } = this.props
    let { jobs, settings } = extractNodesFromData(restData)
    jobs = jobs.filter(({ title }) => title)

    topImage1.alt =
      'Zuri Hybrid VTOL aircraft in forward flight above a modern city skyline at sunrise, representing sustainable air mobility and the future of urban transportation.'
    topImage2.alt =
      'Zuri Hybrid VTOL aircraft hovering above a city waterfront landing zone with passengers onboard, illustrating urban air mobility and real-world infrastructure integration.'
    topImage3.alt =
      'Zuri Hybrid VTOL aircraft landing at a beach resort helipad, as a family arrives for vacation. A real-world example of regional air mobility and sustainable travel.'

    const topImages = [topImage1, topImage2, topImage3]
    settings = settings.find(({ isHpTextVisible }) => isHpTextVisible) || {}

    const { isCareerVisible } = this.state

    return (
      <>
        <SEO
          title="Zuri Hybrid VTOL – Regional Air Mobility with 700 km Range"
          description="Experience Zuri Hybrid VTOL – 700 km range with vertical takeoff and hybrid propulsion for passengers, cargo, and emergency services."
          pathname={pathname}
        />
        <HpTop3 image={topImage} images={topImages} />
        {settings.isHpTextVisible && (
          <Section>
            <Gap gap="110px" mobileGap="40px" bp="tablet" />
            <Row justifyContent="center">
              <Col
                maxWidth="800px"
                mobileMaxWidth="600px"
                bp="tablet"
                alignItems="center"
              >
                <EditorContent
                  dangerouslySetInnerHTML={{ __html: settings.hpText }}
                />
              </Col>
            </Row>
            <Gap gap="110px" mobileGap="40px" bp="tablet" />
          </Section>
        )}

        <Section>
          <Gap gap="110px" mobileGap="40px" bp="tablet" />
          <Row justifyContent="center">
            <Col
              maxWidth="800px"
              mobileMaxWidth="600px"
              bp="tablet"
              alignItems="center"
              mobileAlignItems="flex-start"
            >
              <Title.MediumSmall as="h2">
                REDEFINING REGIONAL AIR MOBILITY.
              </Title.MediumSmall>
              <Gap gap="32px" mobileGap="24px" />
              <MainText>
                <Text.Black style={{ fontWeight: '700' }}>At Zuri, </Text.Black>
                our goal is to change the way people experience on&#8209;demand,
                door&#8209;to&#8209;door mid&#8209;range flights. Travel on your own schedule and
                without airports&#8288;&mdash;&#8288;secured by technology and design that
                prioritize passenger safety and comfort.
              </MainText>
            </Col>
          </Row>
          <Gap gap="140px" mobileGap="80px" bp="mobile" showBelow="tablet" />
          <Gap gap="140px" showAfter="tablet" />
          <Row
            justifyContent="space-between"
            alignItems="center"
            responsive
            bp="tablet"
          >
            <Col maxWidth="525px">
              <PlaneImageWrapper>
                <PlaneVertical src={planeVerticalSrc} alt="Diagram showing propulsion thrust and lift distribution across the aircraft's propellers, highlighting vertical takeoff and landing (VTOL) capabilities." />
              </PlaneImageWrapper>
              <Subtitle>VERTICAL TAKEOFF AND LANDING.</Subtitle>{' '}
              <Gap gap="16px" mobileGap="8px" />
              <MainText>
                Allows you to skip airports and land everywhere from a city's
                periphery to the roof of a skyscraper.
              </MainText>
            </Col>
            <Col
              alignItems="center"
              justifyContent="center"
              showAfter="tablet"
              padding="0 40px"
            >
              <img src={plusIconSrc} alt="" />
            </Col>
            <Gap gap="80px" mobileGap="100px" bp="tablet" showBelow="tablet" />
            <Col maxWidth="575px">
              <PlaneImageWrapper>
                <PlaneHorizontal
                  src={planeHorizontalSrc}
                  alt="Diagram showing forward flight mode of a hybrid VTOL aircraft with thrust vectors representing horizontal propulsion, highlighting aerodynamic efficiency during cruise."
                />
              </PlaneImageWrapper>
              <Subtitle>EFFICIENT HORIZONTAL FLIGHT.</Subtitle> 
              <Gap gap="16px" mobileGap="8px" />
              <MainText>
                The wings provide lift, which means a much better energy consumption
                compared to helicopters or multicopters, resulting in a 700+ km
                range.
              </MainText>
            </Col>
          </Row>
          <Gap gap="60px" mobileGap="40px" bp="tablet" />
        </Section>

        <HpShowReel />

        <Earth fluid={earthImage.image.fluid} />

        <Section
          image={jobsBgImage}
          video={jobsVideo}
          onMouseOver={this.careerOnMouseOver}
          onMouseLeave={this.careerOnMouseLeave}
          isBackgroundOverlaid={!isCareerVisible}
          alt="Video featuring Zuri's 11-meter VTOL test flight, behind-the-scenes footage of the engineering team, and a subscale model in flight, showcasing the technology and teamwork at Zuri."
        >
          <Gap gap="200px" mobileGap="80px" bp="tablet" />
          <Col>
            <Title.Large>LET'S WORK TOGETHER</Title.Large>

            <Gap gap="120px" mobileGap="60px" bp="tablet" />

            {jobs.map(({ title, slug }) => (
              <Fragment key={slug}>
                <Link to={`${Link.CAREER}/#${slug}`}>
                  <Title.Medium>{title}</Title.Medium>
                </Link>
                <Gap gap="40px" />
              </Fragment>
            ))}
          </Col>
          <Gap gap="200px" mobileGap="80px" bp="tablet" />
          <Col alignItems="center">
            <Button.Link to={Link.CAREER}>More jobs</Button.Link>
            <Gap gap="100px" />
          </Col>
        </Section>
      </>
    )
  }
}

export default Index

export const pageQuery = graphql`  query {
    topImage: file(relativePath: { eq: "images/hp/top.jpg" }) {
      ...FullHdImage
    }
    topImage1: file(
      relativePath: {
        eq: "images/hp/zuri-hybrid-vtol-in-flight-above-city-skyline-sustainable-air-mobility.jpg"
      }
    ) {
      ...FullHdImage
    }
    topImage2: file(
      relativePath: {
        eq: "images/hp/zuri-hybrid-vtol-urban-landing-city-waterfront-passenger-arrival.jpg"
      }
    ) {
      ...FullHdImage
    }
    topImage3: file(
      relativePath: {
        eq: "images/hp/zuri-hybrid-vtol-landing-vacation-beach-resort-regional-air-mobility.jpg"
      }
    ) {
      ...FullHdImage
    }

    earthImage: file(
      relativePath: {
        eq: "images/hp/zuri-vtol-range-map-europe-interactive.jpg"
      }
    ) {
      ...FullHdImage
    }
    jobsBgImage: file(relativePath: { eq: "images/hp/jobs-bg.jpg" }) {
      ...FullHdImage
    }

    jobs: allJobs(
      sort: { fields: sortOrder, order: ASC }
      filter: { state: { eq: "published" } }
    ) {
      edges {
        node {
          _id
          slug
          title
        }
      }
    }

    settings: allSettings {
      edges {
        node {
          _id
          modelName
          isHpTextVisible
          hpText
        }
      }
    }
  }
`
